/*
 * File: /src/services/callTypeDetailService.js
 * Created Date: Monday August 17th 2026
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Copyright (c) 2026 AdBase, Inc.
 */

import { authedAxios } from '../shared/axiosWrapper';
import { S2_CALL_TYPE_DETAIL_PATH } from '../constants';

export default {
  fetchAll(callResultTypeId) {
    return authedAxios.get(S2_CALL_TYPE_DETAIL_PATH, {
      params:
        callResultTypeId != undefined
          ? { call_result_type_id: callResultTypeId }
          : {},
    });
  },

  fetchById(id) {
    return authedAxios.get(S2_CALL_TYPE_DETAIL_PATH + id);
  },

  createCallTypeDetail(payload) {
    return authedAxios.post(S2_CALL_TYPE_DETAIL_PATH, payload);
  },

  updateCallTypeDetail(id, payload) {
    return authedAxios.put(S2_CALL_TYPE_DETAIL_PATH + id, payload);
  },

  deleteCallTypeDetail(id) {
    return authedAxios.delete(S2_CALL_TYPE_DETAIL_PATH + id);
  },
};
